import validateIntervals from './ValidateEventIntervals';

const eventEndsBeforeItStarts = (eventObject) => {
  let startDateTime = new Date(
    eventObject.startDate + ' ' + eventObject.startTime
  );
  let endDateTime = new Date(
    eventObject.endDate + ' ' + eventObject.endTime
  );
  return endDateTime <= startDateTime;
};

const eventStartsWithin24Hours = (eventObject, isAdmin) => {
  let now = new Date();
  let startDate = new Date(
    eventObject.startDate + ' ' + eventObject.startTime
  );
  let milliseconds = startDate - now;
  let hours = milliseconds / 1000 / 3600;
  return startDate <= now || (!isAdmin && hours < 24);
};

const validateEventDates = (
  eventObject,
  currentFormErrors,
  invalidIntervalArr,
  store,
  options = {}
) => {
  const { isAdmin = false, isDeveloper = false } = options;

  // make sure that event end time >= start time
  if (eventEndsBeforeItStarts(eventObject)) {
    currentFormErrors.push(
      'Event end time cannot be before event start time.'
    );
  }

  // make sure event start is not within 24 hours
  if (eventStartsWithin24Hours(eventObject, isAdmin)) {
    if (!isDeveloper) {
      currentFormErrors.push('Event start date cannot be within 24 hours');
    }
  }

  // reset interval errors array
  invalidIntervalArr.length = 0;
  store.commit('EVENT_MANAGER_STORE/SET_CURRENT_INTERVAL_ERROR_LIST');

  // validate interval dates
  if (eventObject.contestType !== 'Instant Win') {
    let areIntervalsValid = validateIntervals(
      eventObject.startDate,
      eventObject.startTime,
      eventObject.endDate,
      eventObject.endTime,
      eventObject.intervals
    );
    // run date checks on all of the dates if multiple intervals;
    if (areIntervalsValid.length) {
      invalidIntervalArr.push(...areIntervalsValid);
      store.commit(
        'EVENT_MANAGER_STORE/SET_CURRENT_INTERVAL_ERROR_LIST',
        areIntervalsValid
      );
    }
  }

  // check if eventType = 'HQ Sponsorship' and if it does, require a segment selection;
  if (
    eventObject.eventType === 'HQ Sponsorship' &&
    !eventObject.hqSponsorshipSegment
  ) {
    currentFormErrors.push(
      'You must select a value for HQ Sponsorship Segment.'
    );
  }
};

export { validateEventDates, eventEndsBeforeItStarts, eventStartsWithin24Hours };
